import { Typography, useTheme } from '@material-ui/core';
import { Box } from '@material-ui/core';
import React from 'react';
import { ReactComponent as Logo } from '../resources/images/logo.svg';
import { ContentLayout } from '../components/utilities/layouts/ContentLayout';
import { PrimaryButton } from '../components/utilities/commonUtilities/GenericButtonElements';
import { ReactComponent as WelcomeImage } from '../resources/images/welcome-image.svg';
import { CURRENT_APP_THEME, getLayout } from '../styles/stylesSelector';
import { FullScreenPageNoButton } from '../components/FullScreenButtonPage';
import { SetupAccountStep1WelcomeStyle, stylesOverrideForFullScreenComponent } from '../styles/SetupAccountStep1WelcomeStyle';
import { SETUP_WELCOME_MESSAGE_BODY, SETUP_WELCOME_MESSAGE_TITLE } from '../resources/messages.json';

export const SetupAccountStep1WelcomeLayout = ({
    onNextPage
}) => {

    const theme = useTheme();
    const classes = SetupAccountStep1WelcomeStyle();

    const ned = () => {
        return (
            <Box display="flex" flexDirection="column" className={classes?.pageContainer}>
                <Box display="flex" justifyContent="center" alignItems="center">
                    <Logo aria-labelledby={`${CURRENT_APP_THEME} logo`} className={classes?.logo} />
                </Box>
                <ContentLayout className={classes?.content}>
                    <Typography variant="h1" className={classes?.title}>
                        {SETUP_WELCOME_MESSAGE_TITLE}
                    </Typography>
                    <Typography variant="body1" className={classes?.body}>
                        {SETUP_WELCOME_MESSAGE_BODY}
                    </Typography>
                    <PrimaryButton onClick={onNextPage} className={classes?.button}>
                        Get Started
                    </PrimaryButton>
                </ContentLayout>
                <WelcomeImage aria-labelledby="Hospital logo" className={classes?.hospitalLogo} />
            </Box>
        );
    }

    const watchman = () => {

        const stylesOverride = stylesOverrideForFullScreenComponent(theme);

        const TitleText = () => {
            return (<>
                <h2 className={classes.h2}>
                    <span className={classes.welcomeHeader}>{SETUP_WELCOME_MESSAGE_TITLE}</span>
                    <Logo aria-labelledby={`${CURRENT_APP_THEME} logo`} className={classes?.logo} />
                </h2>
                
            </>);
        }

        return (
            <FullScreenPageNoButton
                isLoginRequired={false}
                Icon={WelcomeImage}
                SubtitleText={TitleText}
                bodyText={SETUP_WELCOME_MESSAGE_BODY}
                buttonText={'Get Started'}
                onButtonClick={onNextPage}
                showShadow={false}
                stylesOverride={stylesOverride}
            />
        );
    }

    return getLayout({
        ned,
        watchman
    });
};
